import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import DashboardPage from './pages/DashboardPage';
import CostosPage from './pages/CostosPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ProfitabilityPage from './pages/ProfitabilityPage';
import InventoryPage from './pages/InventoryPage';
import SettingsPage from './pages/SettingsPage';
import SearchProductsPage from './pages/SearchProductsPage';
import PublicationsPage from './pages/PublicationsPage';
import YujuCallback from './pages/YujuCallback';
import ReindexadoPage from './pages/ReindexadoPage';
import CatalogPage from './pages/CatalogPage';
import BatchReviewPage from './pages/BatchReviewPage';
import { Toaster } from './components/ui/sonner';
import { Toaster as RadixToaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/revision/:token" element={<BatchReviewPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/cost" element={<CostosPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/profitability" element={<ProfitabilityPage />} />
          <Route path="/publications" element={<PublicationsPage />} />
          <Route path="/reindexado" element={<ReindexadoPage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/yuju/callback" element={<YujuCallback />} />
          <Route path="/research" element={<SearchProductsPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          {/* Legacy redirects */}
          <Route path="/costos" element={<Navigate to="/cost" replace />} />
          <Route path="/search-products" element={<Navigate to="/research" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      <RadixToaster />
    </div>
  );
}

export default App;
